var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: {
        bus: _vm.busModal,
        "max-width": "60%",
        "close-color": "#5B5B5B",
        fixedActions: ""
      },
      scopedSlots: _vm._u([
        {
          key: "title",
          fn: function() {
            return [
              _c(
                "div",
                { staticClass: "d-flex align-center az-gap-small mb-4" },
                [
                  _c("Title", {
                    attrs: { title: _vm.title, removeVerticalMargin: "" }
                  }),
                  _c("TranscriptPlatformBadge", {
                    attrs: { platform: _vm.platform }
                  })
                ],
                1
              )
            ]
          },
          proxy: true
        },
        {
          key: "actions",
          fn: function(ref) {
            var close = ref.close
            return [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex align-center justify-end az-gap-small mt-4"
                },
                [
                  _c(
                    "BaseButton",
                    { attrs: { underlined: "" }, on: { click: close } },
                    [_vm._v("Fechar")]
                  ),
                  _vm.canDownloadTranscricao
                    ? _c(
                        "BaseButton",
                        {
                          attrs: {
                            outline: "",
                            fitContent: "",
                            loading: _vm.loadingDownload
                          },
                          on: { click: _vm.handleDownloadTxt }
                        },
                        [_vm._v(" Baixar transcrição (.txt) ")]
                      )
                    : _vm._e(),
                  _vm.canRegenerate
                    ? _c(
                        "BaseButton",
                        {
                          attrs: {
                            primary: "",
                            fitContent: "",
                            loading: _vm.regenerating
                          },
                          on: { click: _vm.handleRegenerate }
                        },
                        [_vm._v(" Gerar novamente ")]
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          }
        }
      ])
    },
    [
      _c("TranscriptClientModal"),
      _c("TranscriptLinkProjectModal"),
      _c("TranscriptParticipantsModal"),
      _c(
        "div",
        { staticClass: "transcript-detail-modal pa-2" },
        [
          _vm.loading && !_vm.transcript
            ? _c(
                "div",
                [
                  _c("div", { staticClass: "mb-4" }, [
                    _c("div", {
                      staticClass:
                        "transcript-detail-modal__skeleton-bar transcript-detail-modal__skeleton-bar--heading mb-3"
                    }),
                    _c("div", {
                      staticClass:
                        "transcript-detail-modal__skeleton-bar transcript-detail-modal__skeleton-bar--medium mb-2"
                    }),
                    _c("div", {
                      staticClass:
                        "transcript-detail-modal__skeleton-bar transcript-detail-modal__skeleton-bar--short mb-2"
                    })
                  ]),
                  _vm._l(5, function(n) {
                    return _c("div", {
                      key: n,
                      staticClass:
                        "transcript-detail-modal__skeleton-bar transcript-detail-modal__skeleton-bar--wide mb-3"
                    })
                  })
                ],
                2
              )
            : [
                _vm.transcript
                  ? _c(
                      "div",
                      [
                        _c("DetailMeetingHeader", {
                          ref: "meetingHeader",
                          attrs: {
                            transcript: _vm.transcript,
                            "start-time-formatted": _vm.startTimeFormatted,
                            duration: _vm.duration,
                            regenerating: _vm.regenerating
                          },
                          on: { regenerate: _vm.handleRegenerate }
                        }),
                        _c(
                          "v-tabs",
                          {
                            staticClass:
                              "transcript-detail-modal__tabs mt-4 mb-4",
                            attrs: { "show-arrows": "" },
                            model: {
                              value: _vm.tab,
                              callback: function($$v) {
                                _vm.tab = $$v
                              },
                              expression: "tab"
                            }
                          },
                          [
                            _c(
                              "v-tab",
                              {
                                staticClass: "text-none",
                                attrs: { href: "#resumo" }
                              },
                              [_vm._v("Resumo")]
                            ),
                            _c(
                              "v-tab",
                              {
                                staticClass: "text-none",
                                attrs: { href: "#sentimento" }
                              },
                              [_vm._v("Sentimento")]
                            ),
                            _c(
                              "v-tab",
                              {
                                staticClass: "text-none",
                                attrs: { href: "#acoes" }
                              },
                              [_vm._v("Ações geradas")]
                            ),
                            _c(
                              "v-tab",
                              {
                                staticClass: "text-none",
                                attrs: { href: "#avaliacao" }
                              },
                              [_vm._v("Avaliação")]
                            ),
                            _c(
                              "v-tab",
                              {
                                staticClass: "text-none",
                                attrs: { href: "#participantes" }
                              },
                              [_vm._v("Participantes")]
                            ),
                            _c(
                              "v-tab",
                              {
                                staticClass: "text-none",
                                attrs: { href: "#transcricao" }
                              },
                              [_vm._v("Transcrição")]
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-tabs-items",
                          {
                            model: {
                              value: _vm.tab,
                              callback: function($$v) {
                                _vm.tab = $$v
                              },
                              expression: "tab"
                            }
                          },
                          [
                            _c(
                              "v-tab-item",
                              { attrs: { value: "resumo" } },
                              [
                                _c("DetailTabResumo", {
                                  attrs: {
                                    summary: _vm.summary,
                                    "ai-status": _vm.aiStatus,
                                    "transcript-status": _vm.transcriptStatus,
                                    loading: _vm.loading,
                                    "can-regenerate": _vm.canRegenerate
                                  },
                                  on: { regenerate: _vm.handleRegenerate }
                                })
                              ],
                              1
                            ),
                            _c(
                              "v-tab-item",
                              { attrs: { value: "sentimento" } },
                              [
                                _c("DetailTabSentimento", {
                                  attrs: { transcript: _vm.transcript }
                                })
                              ],
                              1
                            ),
                            _c(
                              "v-tab-item",
                              { attrs: { value: "acoes" } },
                              [
                                _c("DetailTabAcoes", {
                                  attrs: {
                                    actions: _vm.generatedActions,
                                    "ai-status": _vm.aiStatus
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "v-tab-item",
                              { attrs: { value: "avaliacao" } },
                              [
                                _c("DetailTabAvaliacao", {
                                  attrs: {
                                    transcript: _vm.transcript,
                                    scores: _vm.scores,
                                    loading: _vm.loadingScores
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "v-tab-item",
                              { attrs: { value: "participantes" } },
                              [
                                _c("DetailTabParticipantes", {
                                  attrs: {
                                    "transcript-id": _vm.transcriptId,
                                    participants: _vm.participants
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "v-tab-item",
                              { attrs: { value: "transcricao" } },
                              [
                                _c("DetailTabTranscricao", {
                                  attrs: { transcript: _vm.transcript }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _c(
                      "div",
                      { staticClass: "d-flex flex-column align-center py-8" },
                      [
                        _c("icon-svg", {
                          attrs: {
                            name: "mdi-alert-circle-outline",
                            size: 40,
                            color: "#9E9E9E"
                          }
                        }),
                        _c(
                          "p",
                          {
                            staticClass:
                              "transcript-detail-modal__empty mt-2 mb-0"
                          },
                          [_vm._v("Transcrição não encontrada.")]
                        )
                      ],
                      1
                    )
              ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }